import React from "react";
import { CheckIcon, ShieldCheckIcon, ZapIcon } from "lucide-react";
import { Countdown } from "./Countdown";
import { BuyButton } from "./BuyButton";
const SUMMARY = ["8 Tomos completos (Baby, Infantiles, Cadetes, Juveniles)", "Kit de Planillas de Gestión", "Banco de Ejercicios por Categoría", "Plantillas de Comunicación con Padres", "Planificador Anual con 52 Sesiones", "Guía de Prevención de Lesiones por Edad", "Manual de Corrección Rápida"];
export function FinalOffer() {
  return <section id="compra" className="scroll-mt-4 px-4 py-8" data-id="element-83" data-mp="1legr9p4uxydq">
      <div className="rounded-2xl bg-white p-5 shadow-2xl shadow-black/40" data-id="element-84" data-mp="204eikdy33475">
        <div className="flex items-center justify-center gap-1.5 rounded-full bg-[#8bc34a]/15 px-3 py-1.5 text-center" data-id="element-85" data-mp="206h70tjl8p9r">
          <ZapIcon className="h-4 w-4 text-[#0f2c4a]" data-id="element-86" data-mp="2952o0k9evw8f" />
          <span className="text-xs font-black uppercase text-[#0f2c4a]" data-id="element-87" data-mp="295m55yr8mgle">
            Oferta final por tiempo limitado
          </span>
        </div>

        <h2 className="mt-4 text-center text-2xl font-black text-[#0f2c4a]" data-id="element-88" data-mp="1pozvg4p1qg6">
          Profe Fútbol Resuelto
        </h2>
        <p className="text-center text-sm text-slate-500" data-id="element-89" data-mp="6nqk44duvvt8">Resumen de tu pedido</p>

        <ul className="mt-4 space-y-2 rounded-xl bg-slate-50 p-4" data-id="element-90" data-mp="bnwi02apyejr">
          {SUMMARY.map(s => <li key={s} className="flex items-start gap-2" data-id="element-91" data-mp="gn9069qnaxg0">
              <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#8bc34a]" data-id="element-92" data-mp="gkmsma3r8hxs" />
              <span className="text-sm text-slate-700" data-id="element-93" data-mp="knrtk886sbkb">{s}</span>
            </li>)}
        </ul>

        <div className="mt-5 text-center" data-id="element-94" data-mp="pll1p6t1vfn8">
          <p className="text-sm font-medium text-slate-400 line-through" data-id="element-95" data-mp="uee1dg9nvxsg">
            Precio anterior $50.000
          </p>
          <p className="mt-1 text-4xl font-black text-[#0f2c4a]" data-id="element-96" data-mp="zc5x6ldfg41x">$19.990</p>
          <p className="mt-1 text-xs font-bold uppercase tracking-wide text-[#8bc34a]" data-id="element-97" data-mp="14ctxjxnjpx8t">
            Pago único · Acceso inmediato
          </p>
        </div>

        <div className="mt-5" data-id="element-98" data-mp="18bsyl765p9uz">
          <Countdown data-id="element-99" data-mp="35e9wvihe4dyf" />
        </div>

        <div className="mt-5" data-id="element-100" data-mp="35fb9hre218i9">
          <BuyButton variant="checkout" label="Quiero resolver mis clases de fútbol" data-id="element-101" data-mp="35cfcc5a16nuv" />
          <div className="mt-3 flex items-center justify-center gap-2 text-xs font-medium text-slate-500" data-id="element-102" data-mp="3e6tohyz9li9r">
            <ShieldCheckIcon className="h-4 w-4 text-[#8bc34a]" data-id="element-103" data-mp="39gd8q87z1kk8" />
            Compra 100% segura · Entrega en PDF al instante
          </div>
        </div>
      </div>
    </section>;
}